import { useContext } from "react"
import filterData from "../functions/filterData"
import ModalFormContext from "../store/ModalFormContext"

const useJSONActions = () => {
    const context = useContext(ModalFormContext)
    const getJsonActions = (object_id = null, filter = {}, button_name=null, icon=false, formData = null, callbackFunc = null) => {
        const copy_actions = JSON.parse(JSON.stringify(context.forms)) //making copy in order not to alter all actions
        const return_actions = filterData(copy_actions, filter)
        return return_actions
    }
    return getJsonActions
}

export default useJSONActions

